import { render } from "./NotFound.vue?vue&type=template&id=eb645cf4"
const script = {}
script.render = render

export default script